export default __webpack_public_path__ + "static/media/msg01.bd5a8302.png";